
<template>
  <div class="matchPage">
    <div style="width:100%;">
        <!-- 顶部tabs -->
        <div style="width:100%; background:#fff; border-bottom:1px solid #dfdfdf; position: fixed; top: 0; z-index: 2;">
            <div class="header">
                <div class="left" style="cursor:pointer;" @click="clickLogoImg">
                    <img src="@/assets/img/logo.png" alt="">
                </div>
                <div class="right">
                    <div class="rightItem" :class="index==headerIndex?'activeHeader':''"  v-for="(item, index) in headerArr" :key="index" @click="clickHeaderItem(index)">{{item.name}}</div>
                </div>
            </div>
        </div>
        <!-- banner -->
        <div class="banner">
            <img src="@/assets/img/banner2.png" alt="">
        </div>

        <!-- 提交作品 -->
        <div class="formContent">
            <el-form ref="submitForm" :model="form" :rules="rules" label-width="100px"  label-position='right'>
                <!-- 项目信息 -->
                <div class="workPart">
                    <div class="partTitle">
                        <img src="@/assets/img/submit/line.png" alt="">
                        <span class="titleText">项目信息</span>
                    </div>
                    <!-- 作品状态 -->
                    <el-row>
                        <el-col :span='10'>
                            <div class="examinePart" v-if="signData=='edit'">
                                <div class="result">
                                    <!-- <el-tag v-if="detailData.status=='WAIT_REVIEW'" >等待审核</el-tag>
                                    <el-tag v-else-if="detailData.status=='WAIT_RATING'" >等待评分</el-tag>
                                    <el-tag v-else-if="detailData.status=='REVIEW_FAIL'" type="warning">审核失败</el-tag>
                                    <el-tag v-else-if="detailData.status=='WAIT_PRIZE'" >等待评奖</el-tag>
                                    <el-tag v-else-if="detailData.status=='COMPLETE'" >完成</el-tag> -->
                                    <div class="resultItem"  v-if="detailData.status=='WAIT_REVIEW'" style="color:#f5ca04">
                                        <img src="@/assets/img/submit/ex1.png" alt="" style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                        等待审核
                                    </div>
                                    <div class="resultItem"  v-else-if="detailData.status=='REVIEW_FAIL'"  style="color:#f57c7a">
                                        <img src="@/assets/img/submit/ex3.png" alt="" style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                        审核失败
                                    </div>
                                    <div class="resultItem"  v-else-if="detailData.status=='WAIT_RATING'"  style="color:#147aec">
                                        <img src="@/assets/img/submit/ex4.png" alt=""  style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                        等待评分
                                    </div>
                                    <div class="resultItem"  v-else-if="detailData.status=='WAIT_PRIZE'"  style="color:#744ce8">
                                        <img src="@/assets/img/submit/ex5.png" alt="" style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                        等待评奖
                                    </div>
                                    <div class="resultItem"  v-else-if="detailData.status=='COMPLETE'"  style="color:#48aa01">
                                        <img src="@/assets/img/submit/ex6.png" alt="" style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                        评奖完成
                                    </div>
                                </div>
                                <p class="remark" style="font-size: 15px;" v-show="detailData.status=='REVIEW_FAIL'">审核说明：{{detailData.examineRemark}}</p>
                            </div>
                        </el-col>
                    </el-row>
                    
                    <el-row>
                      <el-col :span='10'>
                        <el-form-item label="项目名称:" prop="title" >
                            <el-input style=""  v-model="form.title"  placeholder="请输入项目名称" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span='10'>
                        <el-form-item label="项目简介:" prop="introduce" >
                            <el-input maxlength="300" show-word-limit  type="textarea" :rows="9" v-model="form.introduce"  placeholder="请输入项目简介" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                           <span style="font-size:14px;">作品外观图：</span>
                      </el-col>
                      <el-col :span='5'>
                        <!-- <el-form-item label="作品图片:" label-width="120px"  >
                            <el-upload
                            :action="uploadImgUrl"
                            list-type="picture-card"
                            :multiple='false'
                            :on-change="handleUploadChange"
                            name="file"
                            :file-list="fileList"
                            :limit="1"
                            :on-exceed="uploadExceed"
                            accept='.jpg,.png'
                            >
                                <i slot="default" class="el-icon-plus"></i>
                                <div slot="file" slot-scope="{file}">
                                <img
                                    class="el-upload-list__item-thumbnail"
                                    :src="file.url" alt=""
                                >
                                <span class="el-upload-list__item-actions">
                                    <span
                                    class="el-upload-list__item-preview"
                                    @click="handlePictureCardPreview(file)"
                                    >
                                    <i class="el-icon-zoom-in"></i>
                                    </span>
                                    <span
                                    class="el-upload-list__item-delete"
                                    @click="handleRemove()"
                                    >
                                    <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                                </div>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </el-form-item> -->
                       
                        <cropper-component :cropperOption='cropperOption'  @giveIcon="giveIcon"></cropper-component>
                        <!-- <div style="font-size:14px; "> 请上传您的作品原型外观图（仅限一张）</div> -->
                      </el-col>
                    </el-row>
                    <!-- 技术贴分享 -->
                    <div class="invitationPart" >
                        <el-row style="text-align:left;">
                          <el-col :span='8'>
                            <el-form-item
                                style="margin-bottom:5px;"
                                label="技术帖："
                                :rules="{
                                required: true, message: '不能为空', trigger: 'blur'
                                }"
                            >
                            </el-form-item>
                          </el-col> 
                        </el-row>
                        <el-row  v-for="(item,index) in invitationArr" :key="item.key">
                            <el-col :span='7'>
                            <el-form-item
                                label="标题："
                                label-width="160px"
                                :rules="{
                                required: true, message: '不能为空', trigger: 'blur'
                                }"
                            >
                                <el-input v-model="item.title"></el-input>
                            </el-form-item>
                            </el-col>
                            <el-col :span='7'>
                            <el-form-item
                                label="链接："
                                :rules="{
                                required: true, message: '不能为空', trigger: 'blur'
                                }"
                            >
                                <el-input v-model="item.link"></el-input>
                            </el-form-item>
                            </el-col>
                            <el-col :span="2" style="padding-left:12px;">
                                <el-button size="small" type="danger" plain  v-show="index!=0"  @click.prevent="removeInvitation(item)">删除</el-button>
                            </el-col>
                            <el-col :span="3" v-show="index==0">
                                <el-button type="success" plain  icon="el-icon-plus" size="small" @click="addInvitation">新增技术帖</el-button>
                            </el-col>
                        </el-row>
                    </div>
                    

                    <el-row class="editorPart">
                      <el-col :span='20'>
                        <el-form-item label="硬件说明:"  prop="hardwareDesc">
                            <vue-tinymce
                                v-model="form.hardwareDesc" 
                                :setup="setup"
                                :setting="setting1" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <div class="editorTips">（请详细说明该项目的硬件部分，包括各模块的功能）</div>
                    <el-row  class="editorPart">
                      <el-col :span='20'>
                        <el-form-item label="软件说明:"  prop="softwareDesc">
                            <vue-tinymce
                                v-model="form.softwareDesc"
                                :setup="setup"
                                :setting="setting1" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <div class="editorTips">（请详细说明该项目的软件部分，包括使用的开发平台、运行代码等）</div>
                    <el-row  class="editorPart">
                      <el-col :span='20'>
                        <el-form-item label="演示效果:"  prop="showCase">
                            <vue-tinymce
                                v-model="form.showCase"
                                :setup="setup"
                                :setting="setting" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <div class="editorTips">（请填写该项目的演示效果如图片、视频等）</div>
                </div>
                
                 <!-- 团队信息 -->
                <div class="teamPart">
                    <div class="partTitle">
                        <img src="@/assets/img/submit/line.png" alt="">
                        <span class="titleText">团队信息</span>
                    </div>
                    <el-row>
                        <el-col :span='10'>
                        <el-form-item label="联系人姓名:" prop="contacter" >
                            <el-input style=""  v-model="form.contacter"  placeholder="请输入联系人姓名" />
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span='10'>
                        <el-form-item label="联系邮箱:" prop="email" >
                            <el-input  v-model="form.email"  placeholder="请输入联系邮箱" />
                        </el-form-item>
                        </el-col>
                    </el-row>
                    
                    <!-- <div style="text-align:left;">
                      <el-button type="primary" icon="el-icon-plus" size="small" @click="addMember">新增成员</el-button>
                    </div> -->
                    <el-row  v-for="(item, index) in memberArr" :key="item.key">
                        <el-col :span='5'>
                        <el-form-item
                            :label="'成员' + (index+1)"
                            :rules="{
                            required: false, message: '不能为空', trigger: 'blur'
                            }"
                        >
                            <el-input v-model="item.name"></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span='5'>
                        <el-form-item
                            :label="'职位' + (index+1)"
                            :rules="{
                            required: false, message: '不能为空', trigger: 'blur'
                            }"
                        >
                            <el-input v-model="item.positioner"></el-input>
                        </el-form-item>
                        </el-col>
                        <el-col :span="3" style=" padding-left: 28px">
                            <el-button size="small" type="danger" plain v-show="index!=0"  @click.prevent="removeMember(item)">删除</el-button>
                        </el-col>
                        <el-col :span="4" v-show="index==0">
                           <el-button type="success" plain icon="el-icon-plus" size="small" @click="addMember">新增成员</el-button>
                        </el-col>
                    </el-row>
                </div>

                <div style="margin-top:30px;">
                    <el-button type="primary" @click="clickSubmit" :loading="submitLoading" ><i class="el-icon-finished" /> 提  交</el-button>
                    <el-button style="margin-left:40px;" v-show="signData=='edit'" type="primary" @click="handleLook" ><i class="el-icon-view" /> 预  览</el-button>
                </div>
            </el-form>
        </div>
    </div>

    <!-- 提示弹框 -->
     <el-dialog title="提示" :visible.sync="dialogVisible" width="500px" append-to-body  @close="hanldeCancel">
        <div style="font-size:20px;"><i style="color:green; margin-right:10px;" class="el-icon-circle-check"></i> 
            <span style="font-size:16px;">作品提交成功，请耐心等待审核。</span>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="hanldeOk">确 定</el-button>
            <el-button type="primary" @click="handleLook"><i class="el-icon-view" /> 预览</el-button>
        </div>
    </el-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import cropperComponent from "./cropperComponent";
import { getAction, postAction, uploadImage } from '@/request/http'//引入封装的get post方法
export default {
  name: 'submitWork',
  components: {
      cropperComponent
  },
  data(){
    return{
       headerArr:[
           {name:'首页'},
           {name:'大赛奖项'},
           {name:'开发套件'},
           {name:'赛程安排'},
           {name:'参赛作品'},
           {name:'往期赛事'},
           {name:'提交作品'},
       ],
       headerIndex:'6',

       form: {
       },
       // 表单校验
       rules: {
        contacter: [{ required: true, message: "请输入联系人姓名", trigger: "blur" }],
        email: [{ required: true, message: "请输入联系邮箱", pattern: /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/, trigger: "blur" }],

        title: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        introduce: [{ required: true, message: "请输入项目简介", trigger: "blur" }],
        hardwareDesc: [{ required: true, message: "请输入硬件说明", trigger: "blur" }],
        softwareDesc: [{ required: true, message: "请输入软件说明", trigger: "blur" }],
        showCase: [{ required: true, message: "请输入演示效果", trigger: "blur" }],
       },
       url:{
        submitUrl:"/saveArtwork",
        detailUrl:"/findArtwork",
        updateWork:"/updateArtwork",
        uploadUrl:"/uploadImage",
       },

        // dialogVisible: false,
        // uploadImgUrl: window._CONFIG['domianURL'] + "uploadImage", // 上传的图片服务器地址
        // fileList:[],
        // dialogImageUrl: '',
        
        memberArr: [
           { name: '', positioner:''},
        ],
        icon:'',//上传图片返回值

        submitLoading:false,

        detailData:{},
        signData:"",
        cropperOption:{
            img: '', //裁剪图片的地址
            autoCrop: true, // 是否默认生成截图框
            autoCropWidth: 400, // 默认生成截图框宽度
            autoCropHeight: 300, // 默认生成截图框高度
            fixedBox: true // 固定截图框大小 不允许改变
        },
        setting1: {
            height: 300,
            language:'zh-Hans',
            branding:false,
            toolbar: ['undo redo | styleselect | bold italic | link image | alignleft | aligncenter | alignright | fontselect | fontsizeselect | textcolor'],
            plugins:'image,  textcolor,',
            images_upload_url: window._CONFIG['uploadURL'] + '/uploadImage',
            images_upload_handler:this.images_upload_handler,
        },
        setting: {
            height: 300,
            language:'zh-Hans',
            branding:false,
            toolbar: ['undo redo | styleselect | bold italic | link image | alignleft | aligncenter | alignright | fontselect | fontsizeselect | media | textcolor'],
            plugins:'image, media, textcolor,',
            images_upload_url: window._CONFIG['uploadURL'] + '/uploadImage',
            images_upload_handler:this.images_upload_handler,
            // video_template_callback: function(data) {
            //     if(data!=null &&  data.source1){
            //         if(data.source1.indexOf("http://")==0){
            //             debugger
            //              return '<video onclick="bodyLoad()" width="' + data.width + '" height="' + data.height 
            //                 + '"' + (data.poster ? ' poster="' + data.poster + '"' : '')
            //                 + ' controls="controls">\n' + '<source src="' + data.source1 + '"' 
            //                 + (data.source1mime ? ' type="' + data.source1mime + '"' : '') + ' />\n'  
            //                 + '</video>';

            //         }
            //     }
            //     console.log('data===',data)
            //     // return ''
            //     // <iframe height=498 width=510 src='https://player.youku.com/embed/XNTg1Nzk3NDYyNA==' frameborder=0 'allowfullscreen'></iframe>
            //     // return '<iframe width="' + data.width + '" height="' + data.height  + ' "allowfullscreen" ' + ' frameborder=0 ' +
            //     //   'src=' + data.source1 + '</iframe>'
            // },
        },
        invitationArr: [
           { title: '', link:''},
        ],

        dialogVisible:false,

    }
  },
  watch:{
    icon(newVal,oldVal){
        console.log('newVal===',newVal)
        this.cropperOption={
            img: newVal?window._CONFIG['uploadURL']+newVal:'', //裁剪图片的地址
            autoCrop: true, // 是否默认生成截图框
            autoCropWidth: 400, // 默认生成截图框宽度
            autoCropHeight: 300, // 默认生成截图框高度
            fixedBox: true, // 固定截图框大小 不允许改变
            outputType: 'png',  //裁剪生成图片的格式（jpeg || png || webp）
        }
    }
  },
    activated(){
    },
    mounted(){
        let token = localStorage.getItem('VOUCHER')
        let mobile = localStorage.getItem('MOBILE') 
        if(token && mobile){
            this.reset()
            this.getWorkDetail()
        }else{
            this.$router.push({ path: '/', query:{indexFromSubmit:'5'}})//路由拦截
        }
       
    //    window.bodyLoad = this.bodyLoadFunction()
    },
    methods:{
        // bodyLoad(event) {
        // var iWidth = 600;                         //弹出窗口的宽度;
        // var iHeight = 400;                        //弹出窗口的高度;
        // //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
        // var iTop = (window.screen.height-30-iHeight)/2;       //获得窗口的垂直位置;
        // var iLeft = (window.screen.width-10-iWidth)/2;        //获得窗口的水平位置;
        // var sourceSrc=event.target.childNode[0].src;
        // window.open(sourceSrc,'_blank','width=600,height=400,top='+iTop+'px,left='+iLeft+'px')
        //     //     var sourceTag=document.getElementsByTagName("source");
        //     //     if(sourceTag!=null && sourceTag.length>0){
        //     // debugger
        //     //             for (var i = 0;i<sourceTag.length; i++) {
        //     //                 var sourceSrc=sourceTag[i].src;
        //     //                 if(sourceSrc!=null && sourceSrc.length>0){
        //     //                     if(sourceSrc.indexOf("http://")==0){
        //     //                         sourceTag[i].parentNode.addEventListener('click',function(){
        //     //                             window.open(sourceSrc,'_blank','width=600,height=400,top='+iTop+'px,left='+iLeft+'px')
        //     //                         });
        //     //                     }
        //     //                 }
        //     //             }
        //     //     }
		// },
        // bodyLoadFunction(event) {
        //     console.log('event---',event)
        //     debugger
        //     var iWidth = 600;                         //弹出窗口的宽度;
        //     var iHeight = 400;                        //弹出窗口的高度;
        //     //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
        //     var iTop = (window.screen.height-30-iHeight)/2;       //获得窗口的垂直位置;
        //     var iLeft = (window.screen.width-10-iWidth)/2;        //获得窗口的水平位置;
        //     var sourceSrc=event.target.childNodes[0].src;
        //     window.open(sourceSrc,'_blank','width=600,height=400,top='+iTop+'px,left='+iLeft+'px')
        //     // var sourceTag=document.getElementsByTagName("source");
		// },

        
        setup(editor) {
            console.log('setup---------',editor)
        },
        // 团队成员
        removeMember(item) {
            var index = this.memberArr.indexOf(item)
            if (index !== -1) {
            this.memberArr.splice(index, 1)
            }
        },
        addMember() {
            this.memberArr.push({
                name: '',
                positioner:'',
                key: Date.now()
            });
        }, 
        // 技术帖
        removeInvitation(item) {
            var index = this.invitationArr.indexOf(item)
            if (index !== -1) {
            this.invitationArr.splice(index, 1)
            }
        },
        addInvitation() {
            this.invitationArr.push({
                title: '',
                link:'',
                key: Date.now()
            });
        }, 

        //点击 顶部导航栏
        clickHeaderItem(i){
            this.headerIndex=i
            console.log('this.headerIndex==',this.headerIndex)
            if(this.headerIndex!='6'){
                this.$router.push({ path: '/', query: { indexFromSubmit: this.headerIndex}})
            }
        },
        //点击左上角logo
        clickLogoImg(){
            window.open('https://www.wch.cn')
        },

        // 获取作品详情(编辑)
        getWorkDetail(){
            let that = this
            var params = {
                token: localStorage.getItem('VOUCHER'),
                mobile: localStorage.getItem('MOBILE') 
            }
            postAction(this.url.detailUrl, params).then((res) => {
                if (res.data.code==200) {
                    this.detailData = res.data.data
                    if(this.detailData.id){
                        this.signData='edit'
                    }else{
                        this.signData='add'
                    }
                    this.form = this.detailData.id?this.detailData:{}
                    this.memberArr = this.detailData.risvcTeamItems? this.detailData.risvcTeamItems : [{ name: '', positioner:''},]
                    this.invitationArr = this.detailData.risvcShareLinkItem ? this.detailData.risvcShareLinkItem : [{ title:'', link:''},]
                   
                    // this.fileList = [
                    //     { url:window._CONFIG['uploadURL']+this.detailData.icon}
                    // ]
                    this.icon = this.detailData.icon?this.detailData.icon:""
                } else {
                    if(res.data.code==508){
                        this.msgError('请重新登录验证！');
                        window.localStorage.removeItem('VOUCHER')
                        window.localStorage.removeItem('MOBILE')
                        setTimeout(function(){
                            that.$router.push({ path: '/', query:{indexFromSubmit:'6'}})
                        },3000);

                    }else{
                        this.msgError(res.data.msg);
                    }
                }
            });
        },
        
        //作品图片上传
        // handleRemove(file,fileList) {
        //     console.log(file);
        //     this.fileList=fileList
        // },
        // handlePictureCardPreview(file) {
        //     this.dialogImageUrl = file.url;
        //     this.dialogVisible = true;
        // },
        // handleUploadChange(file, fileList){
        //     console.log('change,file',file)
        //     console.log('change,fileList',fileList)
        //     if(file.status=='success'){
        //         this.icon = file.response.data
        //         this.fileList=fileList
        //     }
        //     console.log('this.fileList==',this.fileList)
        // },
        // uploadExceed(file, fileList){
        //     this.msgWarning('只限上传一张图片');
        // },

        //子组件传递过来
        // giveFileList(val){
        //     this.fileList=val
        // },
        giveIcon(val){
            this.icon= val
        },
       
        

        //富文本编辑器初始化
        // tinymceEditorInit(){
        //     let that = this
        //     console.log('初始化函数')
        //     tinymce.init({
        //         selector:'#hardTextarea',
        //         language:'zh-Hans',
        //         branding:false,
        //         toolbar: ['undo redo | styleselect | bold italic | link image | alignleft | aligncenter | alignright | fontselect | fontsizeselect | media | textcolor'],
        //         plugins:'image, media, textcolor,',
        //         // convert_urls: false,
        //         setup: function(editor){//实例未渲染
        //             console.log('初始化setup---')
        //             editor.on('click', function(e){
        //             }) 
        //         },
        //         init_instance_callback: function(editor){//实例已渲染
        //             console.log('初始化init_instance')
        //             editor.on('click', function(e){
        //             })
        //         },
        //         // images_upload_url: window._CONFIG['uploadURL'] + that.url.uploadUrl,
        //         images_upload_handler:that.images_upload_handler
        //     })
        
        // },
        // 富文本编辑器中图片上传
        
        images_upload_handler (blobInfo, success, failure) {
            let baseUrl = window._CONFIG['uploadURL']
            const formData = new FormData()                     
            formData.append('file', blobInfo.blob())
            uploadImage(formData).then((res) => {          
                if (res.data.code == 200) {
                   success(baseUrl + res.data.data);// 上传成功之后，将对应完整的图片路径拼接在success的参数中
                }
            }).catch(err => {
            failure('上传失败')
                console.log(err)
            })
        },

        //点击确定
        clickSubmit(){
            let that = this
            console.log('memberArr==',this.memberArr)
            console.log('invitationArr===',this.invitationArr)
            
            var flag1 = false
            var flag2 = false
            
            this.$refs.submitForm.validate(valid => {
             if (valid) {
                let params={...this.form}
                console.log('form',this.form)
                if(!this.icon){
                    this.msgWarning('请上传作品外观图！')
                    return
                }
                if(this.memberArr.length>0){
                    if(this.memberArr.length==1){// 一个数据时可以不传参
                        if(this.memberArr[0].name){
                           params["risvcTeamItem["+0+"].name"]= this.memberArr[0].name
                           params["risvcTeamItem["+0+"].positioner"] = this.memberArr[0].positioner?this.memberArr[0].positioner:""
                        }
                    }else{//大于一条数据必须传参
                        for(var i=0; i<this.memberArr.length; i++){
                            if(this.memberArr[i].name){
                                params["risvcTeamItem["+i+"].name"]= this.memberArr[i].name
                                params["risvcTeamItem["+i+"].positioner"] = this.memberArr[i].positioner?this.memberArr[i].positioner:""
                            }else{
                                flag1 = true
                                this.msgWarning('请输入团队成员！')
                                break;
                            }
                        }
                    }
                }
                if(this.invitationArr.length<1){
                    this.msgWarning('请输入技术帖内容！')
                    return
                }
                if(this.invitationArr.length>0){
                    for(var i=0; i<this.invitationArr.length; i++){
                        if(this.invitationArr[i].title && this.invitationArr[i].link){
                           params["shareLinkItem["+i+"].title"]= this.invitationArr[i].title
                           params["shareLinkItem["+i+"].link"] = this.invitationArr[i].link
                        }else{
                            flag2 = true
                            this.msgWarning('请输入技术帖内容！')
                            break;
                        }
                    }
                }
                if(!flag1 && !flag2){
                    console.log('校验通过')
                    console.log('获取到的存储的令牌和手机号：', localStorage.getItem('VOUCHER'), localStorage.getItem('MOBILE'))
                    this.submitLoading = true
                    // if(params.showCase.indexOf("\"http://")>=0 && params.showCase.indexOf("onclick=")<0 ){
                    //     // const info=params.showCase.replace("\"http://","onclick=\"window.bodyLoad()\" src=\"http://")
                    //     // params.showCase=info
                    // }
                    // var reg= /(http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
                    // var videoSrc = params.showCase.match(reg);
                    // if(videoSrc!=null && videoSrc.length>0){
                    //     var repack='<video controls="controls" width="800" height="450" onclick="bodyLoad()"><source src="'+videoSrc+'/></video>'
                    //     params.showCase=repack
                    // }

                    params.icon = this.icon
                    params.token = localStorage.getItem('VOUCHER')
                    params.mobile = localStorage.getItem('MOBILE')
                    
                
                    let httpUrl = ''
                    if(this.signData=='add'){
                        httpUrl=this.url.submitUrl
                    }else{
                        httpUrl=this.url.updateWork
                        params.id = this.detailData.id
                    }
                    postAction(httpUrl, params).then((res) => {
                        if (res.data.code==200) {
                        //    this.msgSuccess(res.data.msg);
                           this.dialogVisible = true
                        } else {
                            if(res.data.code==508){
                                this.msgError('请重新登录验证！');
                                window.localStorage.removeItem('VOUCHER')
                                window.localStorage.removeItem('MOBILE')
                                setTimeout(function(){
                                    that.$router.push({ path: '/', query:{indexFromSubmit:'5'}})
                                },3000);

                            }else if(res.data.msg=='TIME_END'){
                                this.$alert('作品提交已截止！', '提示', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        // this.$message({
                                        // type: 'info',
                                        // message: `action: ${ action }`
                                        // });
                                    }
                                });
                            }else{
                                this.msgError(res.data.msg);
                            }
                           
                        }
                        this.submitLoading = false
                    });
                }
              }
              
          });

        },

        // 页面初始化
        reset(){
            this.form = {
               
            }
            this.fileList = []
            this.detailData = {}
            this.memberArr = [
              { name: '', positioner:''},
            ]
            this.invitationArr = [
                { title:'', link:''},
            ]
            
        },
        
        // 弹框取消
        hanldeCancel(){
            this.dialogVisible = false
            this.getWorkDetail()
        },
        //确定
        hanldeOk(){
            this.dialogVisible = false
            this.getWorkDetail()
        },
        // 弹框预览
        handleLook(){
            console.log('预览')
            this.$router.push({ path: '/workDetail', query:{view:'1'}})
        },
    },
}
</script>

<style scoped > 
.matchPage{
    width: 1903px;
    /* width: 100%; */
    background: #eeeeef;
}
/* header */
.header{
    width: 80%;
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.header .left{
    font-size: 28px;
    font-weight: 600;
    line-height: 80px;
}
.header .right{
    display: flex;
}
.header .right .rightItem{
    font-size: 20px;
    line-height: 80px;
    margin: 0px 15px;
    width: 100px;
    text-align: center;
    color: #000;
    font-weight: 550;
    cursor: pointer;
}
.header .right .activeHeader{
    color: #008cff;
    border-bottom: 5px solid #008cff;
}
/* banner */
.banner{
    width: 100%;
    height: 416px;
    margin-top: 80px;
}
.banner img{
    width: 100%;
}
/* 表单区域 */
.formContent{
    width: 80%;
    margin: 0 auto;
    padding: 30px;
    background: #fff;
}
.partTitle{
    display: flex;
    margin-bottom: 10px;
}
.partTitle .titleText{
    line-height: 60px;
    font-size: 20px;
    font-weight: 600;
    margin-left: 10px;
}
/* el-divider 修改高度&虚线效果 */
 .el-divider--horizontal{
     margin: 8px 0;
     background: 0 0;
     border-top: 1px dashed #e8eaec;
 } 
.image {
  position: relative;
  
}
.image .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
  }
 .image :hover .mask {
    opacity: 1;
  }
  /deep/.el-upload--picture-card{
    width: 200px;
  }
  .editorPart .el-form-item{
      margin-bottom: 5px;
      margin-top: 25px;
  }
  .editorTips{
    text-align: left;
    padding-left: 100px;
    font-size: 14px;
    margin-top: 15px
  }
  .examinePart{
    /* padding: 10px;
    margin-bottom: 20px;
    border: 3px solid #82bdfb; 
    text-align: left;
    border-radius: 8px; */
    background: #fff;
    padding: 10px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    margin-bottom: 20px;
    border: 1px solid #e9f1fb;
}
.resultItem{
    display: flex;
}
.invitationPart{
  
}

</style>

